import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { round } from 'lodash'
import { Asset } from '@/models/asset'


export default /*#__PURE__*/_defineComponent({
  __name: 'AssetCard',
  props: {
    asset: null,
    showEmptyInventory: { type: Boolean, default: false },
    showEmptyQuantity: { type: Boolean, default: false },
    canEditInventory: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { asset: Asset, showEmptyInventory: boolean, showEmptyQuantity: boolean, canEditInventory: boolean }



const assetTotal = computed<number>(() => {
  if (props.asset && props.asset.conditions) {
    const sum = props.asset.conditions.reduce(
      (a, b) => (a || 0) + (b.quantity || 0),
      0
    )
    return round(sum, 4)
  } else {
    return 0
  }
})

const isAssetEmpty = computed<boolean>(
  () => !props.asset || !props.asset.conditions || props.asset.isEmpty()
)

const showAssetCard = computed<boolean>(
  () => !isAssetEmpty.value || props.showEmptyInventory
)

return { __sfc: true,props, assetTotal, isAssetEmpty, showAssetCard }
}

})